import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { OrderByPipe } from 'src/app/pipe/order-by.pipe';
import { FormatedatePipe } from 'src/app/pipe/UTCTime.pipe';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { Constant, RoleName } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';

@Component({
  selector: 'app-trip-report',
  templateUrl: './trip-report.component.html',

  styleUrls: ['./trip-report.component.css'],
})
export class TripReportComponent implements OnInit, OnChanges {
  @Input('details') reportDetails: any = [];
  public user: ILoggedInUserViewModel;
  estimatedSourceTime: number;
  actualSourceTime: number;
  estimatedDestinationTime: number;
  actualDestinationTime: number;
  actualDoorToDoorTime: number;
  doorToDoorTime: number;
  public sRid: any;
  public loader: boolean = false;
  public timeZone: any;
  public isInternalReadOnly: boolean;
  constructor(private serviceRequestService: ServiceRequestService) {
    this.serviceRequestService.timZoneChange.subscribe((value) => {
      this.timeZone = Constant.selectedTimeZoneShortValue;
    });
    this.timeZone = Constant.selectedTimeZoneShortValue;
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
  }

  ngOnChanges() {
    let serviceList = {
      serviceRequestId: [this.reportDetails.serviceRequestId],
    };
    this.getLegDetail(serviceList);
  }
  public legData: any;
  getLegDetail(id) {
    this.serviceRequestService.getLegDetail(id).subscribe(
      (response) => {
        this.legData = response;
        this.reportDetails.legDetails = this.legData;
        this.openShowReport(this.reportDetails);
      },
      (error) => {
        console.log('Error', error);
      },
    );
  }

  openShowReport(reportDetail) {
    this.estimatedSourceTime = 0;
    this.actualSourceTime = 0;
    this.estimatedDestinationTime = 0;
    this.actualDestinationTime = 0;
    this.actualDoorToDoorTime = 0;
    this.doorToDoorTime = 0;
    this.reportDetails = reportDetail;
    // this.doorToDoorTime = this.calculateMin(
    //   this.reportDetails.plannedDate,
    //   this.reportDetails.plannedEndTime
    // );
    if (this.reportDetails['status'] == 'Completed') {
      this.actualDoorToDoorTime = this.calculateMin(this.reportDetails.actualDate, this.reportDetails.actualEndTime);
    }
    let outBoundLeg = this.legData.filter((x) => x.direction == 'Outbound');
    let inBoundLeg = this.legData.filter((x) => x.direction == 'Inbound');
    outBoundLeg.forEach((item) => {
      this.estimatedSourceTime = this.estimatedSourceTime + this.calculateMin(item.plannedStartTime, item.plannedEndTime);
    });
    outBoundLeg.forEach((item) => {
      this.actualSourceTime = this.estimatedSourceTime + this.calculateMin(item.actualStartTime, item.actualEndTime);
    });
    inBoundLeg.forEach((item) => {
      this.estimatedDestinationTime = this.estimatedSourceTime + this.calculateMin(item.plannedStartTime, item.plannedEndTime);
    });

    inBoundLeg.forEach((item) => {
      this.actualDestinationTime = this.estimatedSourceTime + this.calculateMin(item.actualStartTime, item.actualEndTime);
    });
    this.doorToDoorTime = this.actualSourceTime + this.actualDestinationTime;
  }
  calculateMin(a, b) {
    var date1 = new Date(a);
    var date2 = new Date(b);
    var diffTime = Math.abs(date2.getTime() - date1.getTime());
    return diffTime / (1000 * 60);
    //return (Math.floor(min / 60) + " h " + (min % 60) + " m")
  }
}
